import React, { CSSProperties, ReactNode } from 'react';
import { colors, spacing, borders } from '../../../tokens';
import { useMousePosition } from '../../../hooks/useMousePosition';

export interface CardProps {
  children: ReactNode;
  padding?: keyof typeof spacing;
  style?: CSSProperties;
  enableGlassmorphism?: boolean;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  children,
  padding = 'xl',
  style = {},
  enableGlassmorphism = true,
  className,
}) => {
  const { mousePosition, isHovering, elementRef } = useMousePosition();

  return (
    <div
      ref={elementRef}
      className={className}
      style={{
        position: 'relative',
        backgroundColor: colors.background.primary.default,
        padding: spacing[padding] as string,
        borderRadius: borders.component.card.radius,
        border: `1px solid ${isHovering ? colors.border.emphasis.default : colors.border.default.default}`,
        overflow: 'hidden',
        transition: 'border-color 300ms ease',
        ...style,
      }}
    >
      {/* Glassmorphism spotlight effect */}
      {enableGlassmorphism && isHovering && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            background: `radial-gradient(600px circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(168, 85, 247, 0.15), transparent 40%)`,
            transition: 'opacity 300ms ease',
          }}
        />
      )}
      <div style={{ position: 'relative', zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};
